module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "view"
  }, [_c('router-link', {
    staticClass: "btn color-primary",
    attrs: {
      "to": "/reports/missing-payments"
    }
  }, [_vm._v("Manglende betaling")]), _c('br'), _vm._v(" "), (0) ? _c('router-link', {
    staticClass: "btn color-primary",
    attrs: {
      "to": "/report-invoicability"
    }
  }, [_vm._v("Fakturérbarhed")]) : _vm._e(), _c('br'), _vm._v(" "), _c('router-link', {
    staticClass: "btn color-primary",
    attrs: {
      "to": "/reports/missing-input"
    }
  }, [_vm._v("Manglende data")]), _c('br'), _vm._v(" "), (0) ? _c('router-link', {
    staticClass: "btn color-primary",
    attrs: {
      "to": "/report-project-earnability"
    }
  }, [_vm._v("Opgave-rentabilitet")]) : _vm._e(), _c('br'), _vm._v(" "), (_vm.economy_access) ? _c('router-link', {
    staticClass: "btn color-primary",
    attrs: {
      "to": "/reports/client-earning"
    }
  }, [_vm._v("Kunde-indtjening")]) : _vm._e(), _c('br')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7859ba46","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Reports.vue
// module id = 611
// module chunks = 1